(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Submit the sort form as soon as a shopper picks an option, so the page
  // reloads without needing a separate button.
  document.querySelectorAll('[data-collection-sort]').forEach((form) => {
    const select = form.querySelector('select');
    if (!select) return;
    select.addEventListener('change', () => form.submit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  // The mobile band is a scroll-snap rail, and browsers restore horizontal
  // scroll on reload and on back-forward navigation — so a shopper who once
  // swiped can land mid-rail and read card three as "the first product".
  // Every band starts at its first card, every time the page is shown.
  (function () {
    function rewind() {
      document.querySelectorAll('[data-cstyles-rail]').forEach(function (rail) {
        if (rail.scrollLeft) rail.scrollLeft = 0;
      });
    }

    window.addEventListener('pageshow', rewind); // fires on bfcache restores too

    if (document.readyState !== 'loading') {
      rewind();
    } else {
      document.addEventListener('DOMContentLoaded', rewind);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Close the mobile drawer when a viewport resize reveals the desktop nav,
  // and when a pointer or the Escape key leaves the open drawer.
  const drawers = document.querySelectorAll('[data-header-drawer]');

  const closeAll = () => {
    drawers.forEach((drawer) => drawer.removeAttribute('open'));
  };

  window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
    if (event.matches) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  document.addEventListener('click', (event) => {
    drawers.forEach((drawer) => {
      if (drawer.hasAttribute('open') && !drawer.contains(event.target)) {
        drawer.removeAttribute('open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klaviyo-cart-tracking"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-klaviyo-cart-tracking]');
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var lastSent = 0;

    function isAddToCart(url) {
      if (!url) return false;
      try {
        return new URL(url, window.location.origin).pathname.indexOf('/cart/add') !== -1;
      } catch (error) {
        return String(url).indexOf('/cart/add') !== -1;
      }
    }

    function trackAddedToCart() {
      // One add can surface through more than one path — the form post and a
      // follow-up cart refresh, say. A short window collapses those into the
      // single event the shopper actually performed.
      var now = Date.now();
      if (now - lastSent < 800) return;
      lastSent = now;

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var learnq = (window._learnq = window._learnq || []);

          learnq.push([
            'track',
            'Added to Cart',
            {
              $value: cart.total_price / 100,
              total_price: cart.total_price / 100,
              original_total_price: cart.original_total_price / 100,
              total_discount: cart.total_discount / 100,
              item_count: cart.item_count,
              items: cart.items
            }
          ]);
        })
        .catch(function () {
          /* Tracking must never be the reason an add-to-cart looks broken. */
        });
    }

    var nativeFetch = window.fetch;
    if (typeof nativeFetch !== 'function') return;

    window.fetch = function () {
      var request = arguments[0];
      var url = request && request.url ? request.url : request;
      var response = nativeFetch.apply(this, arguments);

      if (isAddToCart(url)) {
        response
          .then(function (res) {
            if (res && res.ok) trackAddedToCart();
          })
          .catch(function () {});
      }

      return response;
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["likeness-proof"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lk]').forEach((card) => {
    const range = card.querySelector('[data-lk-range]');
    const stage = card.querySelector('.lk__stage');
    if (!range || !stage) return;

    const paint = () => stage.style.setProperty('--lk-reveal', range.value + '%');

    range.addEventListener('input', paint);
    paint();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation"] && !Shopify.designMode) return;
  try {
    
  // `details` gives the accordion, the keyboard and touch behaviour for free.
  // All that is left is the two things it has no opinion about: opening on
  // hover where hovering is a thing, and closing when attention moves away.
  const pointer = window.matchMedia('(hover: hover) and (min-width: 750px)');
  const items = () => document.querySelectorAll('[data-navbar-item]');

  // A document-level listener can be handed a target that is not an element
  // (the document itself, on the way out of the window), and closest() only
  // exists on elements.
  const itemFor = (target) => (target instanceof Element ? target.closest('[data-navbar-item]') : null);

  const closeAll = (except) => {
    items().forEach((item) => {
      if (item !== except) item.open = false;
    });
  };

  document.addEventListener('mouseover', (event) => {
    if (!pointer.matches) return;

    const item = itemFor(event.target);
    if (!item) return;

    item.open = true;
    closeAll(item);
  });

  document.addEventListener('mouseout', (event) => {
    if (!pointer.matches) return;

    const item = itemFor(event.target);
    // relatedTarget is where the pointer went; staying inside the same item
    // (moving from the label down into the panel) must not close it.
    if (!item || item.contains(event.relatedTarget)) return;

    item.open = false;
  });

  document.addEventListener('click', (event) => {
    if (!itemFor(event.target)) closeAll();
  });

  document.addEventListener('focusin', (event) => {
    const item = itemFor(event.target);
    if (item) item.open = true;
    closeAll(item);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-recs]').forEach((root) => {
    const url = root.dataset.url;
    if (!url) return;

    const load = () => {
      fetch(url)
        .then((response) => response.text())
        .then((markup) => {
          const parsed = new DOMParser().parseFromString(markup, 'text/html');
          const fresh = parsed.querySelector('[data-recs]');
          // An empty result means the engine had nothing to say for this
          // product; leaving the section blank is the right outcome.
          if (fresh) root.innerHTML = fresh.innerHTML;
        })
        .catch(() => {});
    };

    if (!('IntersectionObserver' in window)) {
      load();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        load();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );

    observer.observe(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reviews]').forEach(function (root) {
    var grid = root.querySelector('[data-reviews-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-review]'));
    var initial = parseInt(root.dataset.initial, 10) || cards.length;
    var showMore = root.querySelector('[data-reviews-showmore]');
    var sort = root.querySelector('[data-reviews-sort]');
    var shown = initial;

    function number(card, key) {
      return parseFloat(card.dataset[key]) || 0;
    }

    // Only the first batch is visible until asked for. The rest stay in the
    // document rather than being fetched later, so sorting still covers every
    // review and the page needs no second request.
    function paint() {
      cards.forEach(function (card, index) {
        card.hidden = index >= shown;
      });

      if (showMore) showMore.hidden = shown >= cards.length;
    }

    if (showMore) {
      showMore.addEventListener('click', function () {
        shown += initial;
        paint();
      });
    }

    if (sort) {
      sort.addEventListener('change', function () {
        var mode = sort.value;

        // Every comparison falls back to the authored order, so equal ratings
        // keep the sequence the merchant arranged instead of reshuffling on
        // each sort — and "most recent" is simply that order restored.
        var ordered = cards.slice().sort(function (a, b) {
          var by = 0;
          if (mode === 'highest') by = number(b, 'rating') - number(a, 'rating');
          if (mode === 'lowest') by = number(a, 'rating') - number(b, 'rating');
          if (mode === 'photos') by = number(b, 'photos') - number(a, 'photos');
          return by || number(a, 'index') - number(b, 'index');
        });

        ordered.forEach(function (card) {
          grid.appendChild(card);
        });

        cards = ordered;
        shown = initial;
        paint();
      });
    }

    // "Read more" earns its place only where the words actually overflow, so
    // the button is measured in rather than printed on every card.
    cards.forEach(function (card) {
      var body = card.querySelector('[data-review-body]');
      var more = card.querySelector('[data-review-more]');
      if (!body || !more) return;

      if (body.scrollHeight - body.clientHeight > 4) {
        more.hidden = false;
      }

      more.addEventListener('click', function () {
        var open = card.classList.toggle('rvw__card--open');
        more.textContent = open ? 'Show less' : 'Read more';
      });
    });

    // A sent review comes back as a redirect with a query flag on it. Without
    // this the thank-you would render inside a panel that is folded shut.
    var write = root.querySelector('[data-reviews-write]');
    if (write && window.location.search.indexOf('contact_posted=true') !== -1) {
      write.open = true;
    }

    var viewer = root.parentNode.querySelector('[data-reviews-viewer]');
    var frame = viewer && viewer.querySelector('[data-reviews-viewer-frame]');

    if (viewer && frame && typeof viewer.showModal === 'function') {
      // The image is built here rather than sitting empty in the markup, so it
      // can be given the photo's real dimensions and the viewer opens at the
      // right shape instead of snapping into place once the file arrives.
      grid.addEventListener('click', function (event) {
        var button = event.target.closest('[data-review-photo]');
        if (!button) return;

        var image = frame.querySelector('img');
        if (!image) {
          image = document.createElement('img');
          image.className = 'rvw__viewer-img';
          frame.appendChild(image);
        }

        var width = button.dataset.reviewPhotoWidth;
        var height = button.dataset.reviewPhotoHeight;

        if (width && height) {
          image.setAttribute('width', width);
          image.setAttribute('height', height);
        } else {
          image.removeAttribute('width');
          image.removeAttribute('height');
        }

        image.alt = button.dataset.reviewPhotoAlt || '';
        image.src = button.dataset.reviewPhoto;

        viewer.showModal();
      });

      // Clicking the backdrop lands on the dialog itself, never on the image.
      viewer.addEventListener('click', function (event) {
        if (event.target === viewer) viewer.close();
      });
    }

    paint();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductForm {
    constructor(root) {
      this.root = root;
      const data = root.querySelector('[data-variant-data]');

      this.bindGallery();

      if (!data) return;

      try {
        this.variants = JSON.parse(data.textContent);
      } catch (error) {
        return;
      }

      this.idInput = root.querySelector('[data-variant-id]');
      this.priceTarget = root.querySelector('[data-product-price]');
      this.button = root.querySelector('[data-add-to-cart]');
      this.buttonText = root.querySelector('[data-add-to-cart-text]');
      this.optionInputs = Array.from(root.querySelectorAll('[data-option-input]'));

      this.optionInputs.forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange());
      });

      this.bindAxes();
    }

    // A split option: two card groups drive one hidden select. Prices on the
    // count cards depend on the chosen type, so they are filled in here from
    // the variant prices the section printed.
    bindAxes() {
      this.root.querySelectorAll('[data-axis]').forEach((axis) => {
        const select = axis.querySelector('[data-axis-target]');
        if (!select) return;

        // "2 Pets — Doll Charms Only" and "1 Pet — Doll Charm Only" are one
        // type at two counts; matching on a loosened key lets the plural drift
        // in the variant names through.
        const norm = (value) =>
          String(value)
            .toLowerCase()
            .replace(/\bonly\b/g, '')
            .replace(/s\b/g, '')
            .replace(/[^a-z0-9—]+/g, ' ')
            .trim();

        const prices = {};
        (axis.dataset.axisPrices || '').split('||').forEach((pair) => {
          const at = pair.lastIndexOf('=');
          if (at > 0) prices[norm(pair.slice(0, at))] = Number(pair.slice(at + 1));
        });

        const first = axis.dataset.axisFirst;
        const types = Array.from(axis.querySelectorAll('[data-axis-type]'));
        const counts = Array.from(axis.querySelectorAll('[data-axis-count]'));

        const update = () => {
          const type = (types.find((input) => input.checked) || {}).value;
          const count = (counts.find((input) => input.checked) || {}).value;
          if (!type || !count) return;

          const key = norm(count + ' — ' + type);
          const option = Array.from(select.options).find((item) => norm(item.value) === key);
          if (option && select.value !== option.value) {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }

          const base = prices[norm(first + ' — ' + type)];
          counts.forEach((input) => {
            const label = input.nextElementSibling;
            if (!label) return;
            const price = prices[norm(input.value + ' — ' + type)];
            const priceNode = label.querySelector('[data-axis-price]');
            const badge = label.querySelector('[data-axis-badge]');
            const n = parseInt(input.value, 10);
            const compare = base && n > 1 ? base * n : null;
            const saving = compare && price && compare > price ? Math.round((1 - price / compare) * 100) : 0;
            label.classList.toggle('is-unavailable', price == null);
            if (priceNode) {
              priceNode.innerHTML = price == null ? '' : this.money(price) + (saving > 0 ? ' <s>' + this.money(compare) + '</s>' : '');
            }
            if (badge) {
              badge.hidden = !(saving > 0);
              badge.textContent = saving > 0 ? '−' + saving + '%' : '';
            }
          });
        };

        types.concat(counts).forEach((input) => input.addEventListener('change', update));
        update();
      });
    }

    get selectedOptions() {
      const groups = new Map();
      this.optionInputs.forEach((input) => {
        if (input.tagName === 'SELECT') {
          groups.set(input.name, input.value);
        } else if (input.checked) {
          groups.set(input.name, input.value);
        }
      });
      return Array.from(groups.values());
    }

    onOptionChange() {
      const selected = this.selectedOptions;
      const variant = this.variants.find((candidate) =>
        candidate.options.every((option, index) => option === selected[index])
      );

      this.updateSelectedLabels(selected);

      if (!variant) {
        this.setUnavailable();
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;
      this.updatePrice(variant);
      this.updateAvailability(variant);
      this.updateUrl(variant);
      this.showMediaFor(variant);
      this.announce(variant);
    }

    // The variant is this form's to choose, but not its to keep: the
    // personalizer needs it to know how many photographs to ask for, and
    // anything else on the page can listen without reaching in here.
    announce(variant) {
      this.root.dispatchEvent(
        new CustomEvent('product:variant', { bubbles: true, detail: { variant: variant } })
      );
    }

    updateSelectedLabels(selected) {
      selected.forEach((value, index) => {
        const label = this.root.querySelector('[data-option-selected="' + index + '"]');
        if (label) label.textContent = value;
      });
    }

    updatePrice(variant) {
      if (!this.priceTarget) return;
      const wrapper = this.priceTarget.querySelector('.price');
      const price = this.priceTarget.querySelector('.price__current');
      const compare = this.priceTarget.querySelector('.price__compare');
      const onSale = variant.compare_at_price > variant.price;

      // A money format can carry markup of its own, so write it as HTML the
      // same way Liquid does on first paint.
      if (price) price.innerHTML = this.money(variant.price);

      if (compare) {
        compare.hidden = !onSale;
        if (onSale) {
          const node = compare.querySelector('.price__compare-amount');
          if (node) node.innerHTML = this.money(variant.compare_at_price);
        }
      }

      // The sale colour and the screen-reader label belong to the variant, not
      // to the one that happened to render first.
      if (wrapper) {
        wrapper.classList.toggle('price--on-sale', onSale);
        const label = wrapper.querySelector('[data-price-label]');
        if (label) {
          label.textContent = onSale ? wrapper.dataset.labelSale : wrapper.dataset.labelRegular;
        }
      }
    }

    money(cents) {
      const format = this.root.dataset.moneyFormat;
      // Shopify money formats embed a placeholder such as "amount" wrapped in
      // double braces. Build the pattern dynamically so this file never
      // contains a literal Liquid output tag inside JavaScript.
      const open = '\\{' + '\\{';
      const close = '\\}' + '\\}';
      const placeholder = new RegExp(open + '\\s*(\\w+)\\s*' + close);
      const match = format ? format.match(placeholder) : null;
      if (!match) return (cents / 100).toFixed(2);
      return format.replace(placeholder, () => this.amount(cents, match[1]));
    }

    // Separator and precision rules for each of Shopify's amount placeholders,
    // so a switched variant reads exactly like the price Liquid rendered.
    amount(cents, placeholder) {
      let precision = 2;
      let thousands = ',';
      let decimal = '.';

      if (placeholder.indexOf('no_decimals') !== -1) precision = 0;

      if (placeholder.indexOf('comma_separator') !== -1) {
        thousands = '.';
        decimal = ',';
      } else if (placeholder.indexOf('apostrophe_separator') !== -1) {
        thousands = "'";
      } else if (placeholder.indexOf('period_and_space_separator') !== -1) {
        thousands = ' ';
      } else if (placeholder.indexOf('space_separator') !== -1) {
        thousands = ' ';
        decimal = ',';
      }

      const parts = (cents / 100).toFixed(precision).split('.');
      const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    updateAvailability(variant) {
      if (!this.button) return;
      this.button.disabled = !variant.available;
      if (this.buttonText) {
        this.buttonText.textContent = variant.available
          ? this.button.dataset.labelAvailable || this.buttonText.textContent
          : this.button.dataset.labelSoldOut || this.buttonText.textContent;
      }
    }

    setUnavailable() {
      if (this.button) this.button.disabled = true;
      this.announce(null);
    }

    updateUrl(variant) {
      if (!window.history.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    showMediaFor(variant) {
      if (!variant.featured_media) return;
      this.showMedia(String(variant.featured_media.id));
    }

    bindGallery() {
      this.track = this.root.querySelector('[data-gallery-track]');
      if (!this.track) return;

      this.slides = Array.from(this.track.querySelectorAll('[data-media-index]'));
      this.thumbs = Array.from(this.root.querySelectorAll('[data-thumb-index]'));
      this.dots = Array.from(this.root.querySelectorAll('[data-dot-index]'));
      this.prev = this.root.querySelector('[data-gallery-prev]');
      this.next = this.root.querySelector('[data-gallery-next]');
      this.index = 0;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.thumbIndex)));
      });

      if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.index - 1));
      if (this.next) this.next.addEventListener('click', () => this.goTo(this.index + 1));

      // The scroll position is the source of truth: a flick, an arrow and a
      // thumbnail all end up here, so the markers only ever need one writer.
      let frame = null;
      this.track.addEventListener('scroll', () => {
        if (frame) window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(() => this.syncFromScroll());
      });

      const active = this.thumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
      if (active > 0) this.goTo(active, 'auto');
      this.mark(Math.max(active, 0));
    }

    goTo(index, behavior) {
      if (!this.track || !this.slides.length) return;
      const clamped = Math.min(Math.max(index, 0), this.slides.length - 1);
      this.track.scrollTo({
        left: clamped * this.track.clientWidth,
        behavior: behavior || 'smooth',
      });
      this.mark(clamped);
    }

    syncFromScroll() {
      if (!this.track || !this.slides.length) return;
      const width = this.track.clientWidth || 1;
      this.mark(Math.round(this.track.scrollLeft / width));
    }

    mark(index) {
      if (index === this.index && this.marked) return;
      this.index = index;
      this.marked = true;

      this.thumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', Number(thumb.dataset.thumbIndex) === index);
      });
      this.dots.forEach((dot) => {
        dot.classList.toggle('is-active', Number(dot.dataset.dotIndex) === index);
      });

      if (this.prev) this.prev.disabled = index <= 0;
      if (this.next) this.next.disabled = index >= this.slides.length - 1;

      const thumb = this.thumbs[index];
      if (thumb && thumb.parentElement && thumb.parentElement.parentElement) {
        const row = thumb.parentElement.parentElement;
        if (row.scrollWidth > row.clientWidth) {
          const target = thumb.offsetLeft - (row.clientWidth - thumb.clientWidth) / 2;
          row.scrollTo({ left: Math.max(target, 0), behavior: 'smooth' });
        }
      }
    }

    showMedia(mediaId) {
      if (!this.slides) return;
      const slide = this.slides.find((candidate) => candidate.dataset.mediaId === mediaId);
      if (slide) this.goTo(Number(slide.dataset.mediaIndex));
    }
  }

  /* The add-on boxes are not form fields. A request to /cart/add makes one
     line item, so a checkbox posted alongside the product is read by nobody
     and dropped in silence — which is what the ticked add-ons were doing.

     On a made-from-photos product the personalizer already posts the basket,
     these boxes included, and this class only keeps the cards looking like
     what is ticked. On the plain form it does the posting itself: product
     and add-ons in one request, each add-on its own line, then the cart. */
  class ProductUpsell {
    constructor(root, formatter) {
      this.root = root;
      // The product form already knows how to write this shop's money; the
      // total below borrows it rather than keeping a second copy.
      this.formatter = formatter;
      this.inputs = Array.from(root.querySelectorAll('[data-upsell-input]'));

      this.buttons = root.querySelector('[data-product-buttons]');
      this.inputs.forEach((input) => {
        input.addEventListener('change', () => this.onChange(input));
      });
      this.syncExpress();

      if (root.querySelector('[data-charm]')) return;

      this.form = root.querySelector('[data-product-form]');
      if (!this.form) return;

      this.idInput = this.form.querySelector('[data-variant-id]');
      this.quantityInput = this.form.querySelector('[name="quantity"]');
      this.button = this.form.querySelector('[data-add-to-cart]');
      this.buttonText = this.form.querySelector('[data-add-to-cart-text]');
      this.errorNode = this.form.querySelector('[data-cart-error]');
      this.totalNode = this.form.querySelector('[data-cart-total]');
      this.unitPrice = this.totalNode ? Number(this.totalNode.dataset.unitPrice) || 0 : 0;

      if (this.quantityInput) {
        this.quantityInput.addEventListener('input', () => this.syncTotal());
      }

      // The swatches own the variant and announce every change; the total has
      // to land on the price they chose.
      this.root.addEventListener('product:variant', (event) => {
        const variant = event.detail && event.detail.variant;
        if (variant) this.unitPrice = variant.price;
        this.syncTotal();
      });

      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.syncTotal();
    }

    onChange(input) {
      const card = input.closest('.product__upsell-card');
      if (card) card.classList.toggle('is-selected', input.checked);
      this.syncExpress();
      this.syncTotal();
    }

    // What the basket will come to, counted where the shopper can see it —
    // the same sum the personalized form keeps in its own bar.
    syncTotal() {
      const quantity = Number(this.quantityInput && this.quantityInput.value) || 1;
      let total = this.unitPrice * quantity;
      this.chosen.forEach((input) => {
        total += Number(input.dataset.charmExtraPrice) || 0;
      });
      // innerHTML, not textContent: a money format can carry markup of its own.
      const html = this.money(total);
      if (this.totalNode) this.totalNode.innerHTML = html;

      // The sticky bar repeats this figure wherever the shopper has scrolled to.
      this.root.dispatchEvent(
        new CustomEvent('product:total', {
          bubbles: true,
          detail: { total: total, html: html, extras: this.chosen.length },
        })
      );
    }

    money(cents) {
      if (this.formatter) return this.formatter.money(cents);
      return (cents / 100).toFixed(2);
    }

    get chosen() {
      return this.inputs.filter((input) => input.checked);
    }

    // "Buy it now" checks out this product on its own, so it cannot be left
    // standing next to an add-on the shopper has already ticked.
    syncExpress() {
      if (!this.buttons) return;
      this.buttons.classList.toggle('product__buttons--no-express', this.chosen.length > 0);
    }

    async onSubmit(event) {
      const chosen = this.chosen;
      if (!this.idInput || !this.idInput.value) return;

      event.preventDefault();
      this.setBusy(true);
      this.showError('');

      const title = this.root.dataset.productTitle;
      const items = [
        {
          id: Number(this.idInput.value),
          quantity: Number(this.quantityInput && this.quantityInput.value) || 1,
        },
      ];

      // An add-on is its own line at its own price, so the order has to say
      // what it was bought for — the same note the personalizer leaves.
      chosen.forEach((input) => {
        const item = { id: Number(input.value), quantity: 1 };
        if (title) item.properties = { 'Added to': title };
        items.push(item);
      });

      // Locale-aware, the way the docs ask: a market that serves this page
      // from /en-in/ answers to /en-in/cart/add.js and nothing else.
      const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      try {
        const response = await fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        });

        const payload = await response.json().catch(() => null);

        if (!response.ok) {
          throw new Error((payload && (payload.description || payload.message)) || '');
        }

        // The cart panel takes it from here; without one, the cart page does.
        if (window.MimoraCart) {
          await window.MimoraCart.added();
          this.setBusy(false);
        } else {
          window.location.href = this.root.dataset.cartUrl || '/cart';
        }
      } catch (error) {
        this.showError(error.message || (this.button && this.button.dataset.labelFailed));
        this.setBusy(false);
      }
    }

    setBusy(busy) {
      if (!this.button) return;
      this.button.disabled = busy;
      if (!this.buttonText) return;
      this.buttonText.textContent = busy
        ? this.button.dataset.labelBusy
        : this.button.dataset.labelAvailable;
    }

    showError(message) {
      if (!this.errorNode) return;
      this.errorNode.textContent = message || '';
      this.errorNode.hidden = !message;
    }
  }

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    new ProductUpsell(root, new ProductForm(root));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-videos"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reels]').forEach(function (root) {
    var track = root.querySelector('[data-reels-track]');
    if (!track) return;

    var videos = track.querySelectorAll('video');

    // Play only what is on screen. A dozen autoplaying reels on a product page
    // is otherwise a phone's whole data budget spent below the fold.
    if ('IntersectionObserver' in window && videos.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              var playing = video.play();
              if (playing && playing.catch) playing.catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.35 }
      );

      videos.forEach(function (video) {
        observer.observe(video);
      });
    }

    function setHidden(el, on) {
      if (!el) return;
      if (on) {
        el.setAttribute('hidden', '');
      } else {
        el.removeAttribute('hidden');
      }
    }

    // Sound is exclusive: turning one tile on turns every other one off.
    track.addEventListener('click', function (event) {
      var button = event.target.closest('[data-reels-sound]');
      if (!button) return;

      var card = button.closest('li');
      var video = card && card.querySelector('video');
      if (!video) return;

      var wasMuted = video.muted;

      videos.forEach(function (other) {
        other.muted = true;
      });
      track.querySelectorAll('[data-reels-sound]').forEach(function (other) {
        setHidden(other.querySelector('.reels__ic--mute'), false);
        setHidden(other.querySelector('.reels__ic--on'), true);
      });

      if (wasMuted) {
        video.muted = false;
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
        setHidden(button.querySelector('.reels__ic--mute'), true);
        setHidden(button.querySelector('.reels__ic--on'), false);
      }
    });

    var prev = root.querySelector('[data-reels-prev]');
    var next = root.querySelector('[data-reels-next]');

    function step() {
      var card = track.querySelector('li');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return (card.getBoundingClientRect().width + gap) * 2;
    }

    function update() {
      var overflows = track.scrollWidth > track.clientWidth + 8;
      if (prev) prev.hidden = !overflows;
      if (next) next.hidden = !overflows;
      if (!overflows) return;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ugc]').forEach(function (root) {
    var track = root.querySelector('[data-ugc-track]');
    if (!track) return;

    var videos = track.querySelectorAll('video');

    // Autoplay muted while on screen, pause off screen: reel behaviour, and it
    // saves the shopper a lot of data on a long page.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              var playing = video.play();
              if (playing && playing.catch) playing.catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.4 }
      );
      videos.forEach(function (video) {
        io.observe(video);
      });
    }

    // Tapping the sound chip unmutes this card and mutes every other one.
    function setHidden(el, on) {
      if (!el) return;
      if (on) {
        el.setAttribute('hidden', '');
      } else {
        el.removeAttribute('hidden');
      }
    }

    track.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ugc-sound]');
      if (!button) return;

      var card = button.closest('figure');
      var video = card && card.querySelector('video');
      if (!video) return;

      var wasMuted = video.muted;

      videos.forEach(function (other) {
        other.muted = true;
      });
      track.querySelectorAll('[data-ugc-sound]').forEach(function (other) {
        setHidden(other.querySelector('.ugc__ic--mute'), false);
        setHidden(other.querySelector('.ugc__ic--on'), true);
      });

      if (wasMuted) {
        video.muted = false;
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
        setHidden(button.querySelector('.ugc__ic--mute'), true);
        setHidden(button.querySelector('.ugc__ic--on'), false);
      }
    });

    // Desktop arrows page by two cards, disable at the ends, and hide entirely
    // when the rail does not overflow.
    var prev = root.querySelector('[data-ugc-prev]');
    var next = root.querySelector('[data-ugc-next]');

    function step() {
      var card = track.querySelector('figure');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return (card.getBoundingClientRect().width + gap) * 2;
    }

    function update() {
      var overflows = track.scrollWidth > track.clientWidth + 8;
      if (prev) prev.hidden = !overflows;
      if (next) next.hidden = !overflows;
      if (!overflows) return;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
